(function () {
  var passthroughKeys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'fbclid',
    'gclid'
  ];
  var activePanelState = {
    bookingBackend: 'peek',
    tourOption: 'Standard Tour',
    tourValue: '18',
    timing: 'Today',
    timingKey: 'today',
    guests: '2',
    dateLabel: 'Today',
    dateIso: '',
    timeSlot: '3:00 PM',
    slotTitle: 'Brewery Tour'
  };
  var eveyVenueTimeZone = 'America/New_York';
  var eveyBookingCutoffHours = 24;

  function closest(target, selector) {
    if (!target || target === document) return null;
    return target.closest ? target.closest(selector) : null;
  }

  function pad(number) {
    return String(number).padStart(2, '0');
  }

  function dateFromOffset(offset) {
    var date = new Date();
    date.setHours(12, 0, 0, 0);
    date.setDate(date.getDate() + offset);
    return date;
  }

  function toIsoDate(date) {
    return [date.getFullYear(), pad(date.getMonth() + 1), pad(date.getDate())].join('-');
  }

  function formatDate(date, options) {
    return date.toLocaleDateString(undefined, options);
  }

  function addDays(date, days) {
    var next = new Date(date.getTime());
    next.setDate(next.getDate() + days);
    return next;
  }

  function fetchWithTimeout(url, options, timeoutMs) {
    var controller;
    var timer;

    if (!window.AbortController) {
      return fetch(url, options || {});
    }

    controller = new AbortController();
    timer = window.setTimeout(function () {
      controller.abort();
    }, timeoutMs);

    return fetch(url, Object.assign({}, options || {}, { signal: controller.signal }))
      .finally(function () {
        window.clearTimeout(timer);
      });
  }

  function longDateLabel(date) {
    return formatDate(date, { weekday: 'long', month: 'short', day: 'numeric' });
  }

  function shortDateLabel(date) {
    return formatDate(date, { month: 'short', day: 'numeric' });
  }

  function weekdayLabel(date) {
    return formatDate(date, { weekday: 'short' });
  }

  function eveyDisplayDate(value) {
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;

    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  }

  function zonedNow(timeZone) {
    var formatter;
    var parts;
    var values = {};

    if (!window.Intl || !Intl.DateTimeFormat) return new Date();

    try {
      formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });
      parts = formatter.formatToParts(new Date());
    } catch (error) {
      return new Date();
    }

    parts.forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = part.value;
    });

    return new Date(
      Number(values.year),
      Number(values.month) - 1,
      Number(values.day),
      Number(values.hour),
      Number(values.minute),
      Number(values.second || 0)
    );
  }

  function isEveyOutsideBookingCutoff(event) {
    var start = eveyDisplayDate(event.start);
    var now = zonedNow(eveyVenueTimeZone);
    var cutoffMs = eveyBookingCutoffHours * 60 * 60 * 1000;

    if (!start) return false;
    return start.getTime() - now.getTime() >= cutoffMs;
  }

  function formatTime(date) {
    if (!date) return '';

    return date
      .toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })
      .replace(/:00/g, '')
      .replace(/\s/g, ' ');
  }

  function formatEveyEventLabel(event) {
    var start = eveyDisplayDate(event.start);
    var end = eveyDisplayDate(event.end);
    var dateLabel;
    var timeLabel;

    if (!start) return '';

    dateLabel = start.toLocaleDateString(undefined, {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
    timeLabel = formatTime(start);

    if (end) timeLabel += ' - ' + formatTime(end);

    return dateLabel + ' at ' + timeLabel;
  }

  function formatEveyButtonDate(event) {
    var start = eveyDisplayDate(event.start);
    if (!start) return '';

    return start.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
  }

  function formatEveyButtonTime(event) {
    var start = eveyDisplayDate(event.start);
    var end = eveyDisplayDate(event.end);
    var label = formatTime(start);

    if (end) label += ' - ' + formatTime(end);
    return label;
  }

  function eveyEventValue(event) {
    var start = Math.floor(new Date(event.start).valueOf() / 1000);
    var end = event.end ? Math.floor(new Date(event.end).valueOf() / 1000) : null;

    if (!Number.isFinite(start) || !event.schedule_item_id) return '';
    return end ? [start, event.schedule_item_id, end].join('|') : [start, event.schedule_item_id].join('|');
  }

  function eveyEventDateKey(event) {
    var start = eveyDisplayDate(event.start);
    return start ? toIsoDate(start) : '';
  }

  function uniqueDateKeys(events) {
    return events.reduce(function (keys, event) {
      var key = eveyEventDateKey(event);
      if (key && keys.indexOf(key) === -1) keys.push(key);
      return keys;
    }, []);
  }

  function slotTitle() {
    return activePanelState.tourOption === 'Tour + Tasting' ? 'Tour + Tasting' : 'Brewery Tour';
  }

  function mockSlots(timingKey) {
    var title = slotTitle();
    var slots = [
      { time: '11:00 AM', title: title, note: 'Easy before lunch' },
      { time: '1:00 PM', title: title, note: 'Good midday slot' },
      { time: '3:00 PM', title: title, note: 'Most popular' },
      { time: '5:00 PM', title: title, note: 'Before dinner' }
    ];

    if (timingKey === 'today') return slots.slice(2);
    if (timingKey === 'tomorrow') return slots.slice(1);
    return slots;
  }

  function getSlots(timingKey, date) {
    var provider = window.mocamaToursAvailability;

    if (provider && typeof provider.getSlots === 'function') {
      var providedSlots = provider.getSlots({
        timingKey: timingKey,
        date: toIsoDate(date),
        tourOption: activePanelState.tourOption,
        guests: activePanelState.guests
      });

      if (Array.isArray(providedSlots)) return providedSlots;
    }

    return mockSlots(timingKey);
  }

  function countAvailable(slots) {
    return slots.filter(function (slot) {
      return slot.available !== false;
    }).length;
  }

  function withBookingParams(url, params) {
    var bookingUrl;
    try {
      bookingUrl = new URL(url, window.location.href);
    } catch (error) {
      return url;
    }

    var pageParams = new URLSearchParams(window.location.search);
    passthroughKeys.forEach(function (key) {
      var value = pageParams.get(key);
      if (value && !bookingUrl.searchParams.has(key)) {
        bookingUrl.searchParams.set(key, value);
      }
    });

    Object.keys(params).forEach(function (key) {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        bookingUrl.searchParams.set(key, params[key]);
      }
    });

    return bookingUrl.toString();
  }

  function updateLink(link, placement) {
    var baseUrl = link.dataset.peekBaseUrl || link.getAttribute('href');
    var selected = {
      tour_option: activePanelState.tourOption,
      timing_intent: activePanelState.timing,
      preferred_date: activePanelState.dateIso,
      preferred_date_label: activePanelState.dateLabel,
      preferred_time: activePanelState.timeSlot,
      booking_product: activePanelState.slotTitle,
      guests: activePanelState.guests,
      booking_backend: activePanelState.bookingBackend === 'evey' ? 'evey_shopify' : 'peek',
      booking_source: 'mocama_tours_page',
      booking_placement: placement || link.dataset.bookingPlacement || 'page_link'
    };
    var nextUrl = withBookingParams(baseUrl, selected);

    link.href = nextUrl;
    link.dataset.peekBookingLink = 'true';
    link.dataset.tourOption = activePanelState.tourOption;
    link.dataset.tourValue = activePanelState.tourValue;
    link.dataset.timingIntent = activePanelState.timing;
    link.dataset.timingKey = activePanelState.timingKey;
    link.dataset.dateLabel = activePanelState.dateLabel;
    link.dataset.dateIso = activePanelState.dateIso;
    link.dataset.timeSlot = activePanelState.timeSlot;
    link.dataset.slotTitle = activePanelState.slotTitle;
    link.dataset.guestCount = activePanelState.guests;
    link.dataset.bookingPlacement = selected.booking_placement;
  }

  function updateEveyHandoffLink(link, placement) {
    var baseUrl = link.dataset.eveyHandoffBaseUrl || link.getAttribute('href');
    var panel = closest(link, '[data-tours-booking-panel]');
    var activeTour = panel ? panel.querySelector('[data-tour-option][aria-pressed="true"]') : null;
    var selected = {
      tour_option: activePanelState.tourOption,
      guests: activePanelState.guests,
      quantity: activePanelState.guests,
      variant: activeTour ? activeTour.dataset.eveyVariantId : '',
      booking_backend: 'evey_shopify',
      booking_source: 'mocama_tours_page',
      booking_placement: placement || link.dataset.bookingPlacement || 'page_link'
    };
    var nextUrl = withBookingParams(baseUrl, selected);

    link.href = nextUrl;
    link.dataset.tourOption = activePanelState.tourOption;
    link.dataset.tourValue = activePanelState.tourValue;
    link.dataset.guestCount = activePanelState.guests;
    link.dataset.bookingBackend = 'evey_shopify';
    link.dataset.bookingPlacement = selected.booking_placement;
  }

  function syncAllPeekLinks() {
    document.querySelectorAll('a[href*="book.peek.com"], a[data-peek-base-url]').forEach(function (link) {
      if (!link.dataset.peekBaseUrl) {
        link.dataset.peekBaseUrl = link.getAttribute('href');
      }
      updateLink(link);
    });
  }

  function setPressed(buttons, activeButton) {
    buttons.forEach(function (button) {
      button.setAttribute('aria-pressed', button === activeButton ? 'true' : 'false');
    });
  }

  function clear(node) {
    while (node && node.firstChild) {
      node.removeChild(node.firstChild);
    }
  }

  function makeDateButton(offset, selectedOffset) {
    var date = dateFromOffset(offset);
    var button = document.createElement('button');
    var weekday = document.createElement('strong');
    var monthDay = document.createElement('span');

    button.className = 'tours-booking__date-choice';
    button.type = 'button';
    button.dataset.dateChoice = String(offset);
    button.dataset.dateIso = toIsoDate(date);
    button.dataset.dateLabel = longDateLabel(date);
    button.setAttribute('aria-pressed', offset === selectedOffset ? 'true' : 'false');

    weekday.textContent = offset === 0 ? 'Today' : weekdayLabel(date);
    monthDay.textContent = shortDateLabel(date);
    button.appendChild(weekday);
    button.appendChild(monthDay);

    return button;
  }

  function makeSlotButton(slot, index) {
    var button = document.createElement('button');
    var time = document.createElement('strong');
    var title = document.createElement('span');
    var note = document.createElement('span');

    button.className = 'tours-booking__slot';
    button.type = 'button';
    button.dataset.timeSlot = slot.time;
    button.dataset.slotTitle = slot.title || slotTitle();
    button.setAttribute('aria-pressed', index === 0 && slot.available !== false ? 'true' : 'false');

    if (slot.available === false) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    }

    time.textContent = slot.time;
    title.textContent = slot.title || slotTitle();
    note.textContent = slot.note || 'Available';
    button.appendChild(time);
    button.appendChild(title);
    button.appendChild(note);

    return button;
  }

  function selectedDateOffsetFor(panel, timingKey) {
    if (timingKey === 'today') return 0;
    if (timingKey === 'tomorrow') return 1;

    var currentOffset = parseInt(panel.dataset.selectedDateOffset || '2', 10);
    return Number.isFinite(currentOffset) && currentOffset >= 0 ? currentOffset : 2;
  }

  function renderAvailability(panel) {
    var activeTiming = panel.querySelector('[data-timing-intent][aria-pressed="true"]');
    var timingKey = activeTiming ? activeTiming.dataset.timingIntent : 'today';
    var timingLabel = activeTiming ? activeTiming.dataset.timingLabel : 'Today';
    var selectedOffset = selectedDateOffsetFor(panel, timingKey);
    var selectedDate = dateFromOffset(selectedOffset);
    var title = panel.querySelector('[data-availability-title]');
    var count = panel.querySelector('[data-availability-count]');
    var dateStrip = panel.querySelector('[data-date-strip]');
    var slotGrid = panel.querySelector('[data-slot-grid]');
    var summary = panel.querySelector('[data-availability-summary]');
    var slots = getSlots(timingKey, selectedDate);
    var availableCount = countAvailable(slots);

    panel.dataset.selectedDateOffset = String(selectedOffset);

    if (title) title.textContent = timingKey === 'pick' ? longDateLabel(selectedDate) : timingLabel + ', ' + shortDateLabel(selectedDate);
    if (count) count.textContent = availableCount === 1 ? '1 time' : availableCount + ' times';

    if (dateStrip) {
      clear(dateStrip);
      if (timingKey === 'pick') {
        dateStrip.removeAttribute('hidden');
        for (var offset = 2; offset <= 8; offset += 1) {
          dateStrip.appendChild(makeDateButton(offset, selectedOffset));
        }
      } else {
        dateStrip.setAttribute('hidden', '');
      }
    }

    if (slotGrid) {
      clear(slotGrid);
      slots.forEach(function (slot, index) {
        slotGrid.appendChild(makeSlotButton(slot, index));
      });
    }

    var firstSlot = slots.filter(function (slot) {
      return slot.available !== false;
    })[0];

    if (summary && firstSlot) {
      summary.textContent = 'Selected: ' + (firstSlot.title || slotTitle()) + ' at ' + firstSlot.time + ' on ' + longDateLabel(selectedDate) + '.';
    }
  }

  function readPanelState(panel) {
    var bookingBackend = panel.dataset.bookingBackend || 'peek';
    var activeTour = panel.querySelector('[data-tour-option][aria-pressed="true"]');
    var activeTiming = panel.querySelector('[data-timing-intent][aria-pressed="true"]');
    var activeDate = panel.querySelector('[data-date-choice][aria-pressed="true"]');
    var activeSlot = panel.querySelector('[data-time-slot][aria-pressed="true"]');
    var activeEveyTime = panel.querySelector('[data-evey-time-option][aria-pressed="true"]');
    var guestOutput = panel.querySelector('[data-guest-count]');
    var tourOption = activeTour ? activeTour.dataset.tourOption : activePanelState.tourOption;
    var fallbackTimingKey = activePanelState.timingKey === 'evey' ? 'today' : activePanelState.timingKey;
    var timingKey = activeTiming ? activeTiming.dataset.timingIntent : fallbackTimingKey;
    var selectedOffset;
    var selectedDate;
    var timingLabel;
    var dateLabel;
    var dateIso;
    var timeSlot;
    var bookingProduct;

    if (bookingBackend === 'evey') {
      timingLabel = 'Live availability';
      timingKey = 'evey';
      dateLabel = activeEveyTime ? activeEveyTime.dataset.dateLabel : '';
      dateIso = '';
      timeSlot = activeEveyTime ? activeEveyTime.dataset.timeSlot : '';
      bookingProduct = tourOption;
    } else {
      selectedOffset = selectedDateOffsetFor(panel, timingKey);
      selectedDate = activeDate ? null : dateFromOffset(selectedOffset);
      timingLabel = activeTiming ? activeTiming.dataset.timingLabel : activePanelState.timing;
      dateLabel = activeDate ? activeDate.dataset.dateLabel : longDateLabel(selectedDate);
      dateIso = activeDate ? activeDate.dataset.dateIso : toIsoDate(selectedDate);
      timeSlot = activeSlot ? activeSlot.dataset.timeSlot : activePanelState.timeSlot;
      bookingProduct = activeSlot ? activeSlot.dataset.slotTitle : slotTitle();
    }

    activePanelState = {
      bookingBackend: bookingBackend,
      tourOption: tourOption,
      tourValue: activeTour ? activeTour.dataset.tourValue : activePanelState.tourValue,
      timing: timingLabel,
      timingKey: timingKey,
      guests: guestOutput ? guestOutput.textContent.trim() : activePanelState.guests,
      dateLabel: dateLabel,
      dateIso: dateIso,
      timeSlot: timeSlot,
      slotTitle: bookingProduct
    };
  }

  function setInputValue(input, value) {
    if (!input || value === undefined || value === null || value === '') return;

    value = String(value);
    if (input.value === value) return;

    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function clearInputValue(input) {
    if (!input || input.value === '') return;

    input.value = '';
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function assignHiddenInputValue(input, value) {
    if (!input) return;
    input.value = value === undefined || value === null ? '' : String(value);
  }

  function getEveyVariantId(panel) {
    var activeTour = panel.querySelector('[data-tour-option][aria-pressed="true"]');
    return activeTour ? activeTour.dataset.eveyVariantId : '';
  }

  function getGuestCount(panel) {
    var guestOutput = panel.querySelector('[data-guest-count]');
    var guestCount = parseInt(guestOutput ? guestOutput.textContent.trim() : activePanelState.guests, 10);
    return Number.isFinite(guestCount) ? guestCount : 1;
  }

  function fetchEveySchedule(panel) {
    var liveTimes = panel.querySelector('[data-evey-live-times]');
    var shop = liveTimes ? liveTimes.dataset.eveyShop : '';
    var productId = liveTimes ? liveTimes.dataset.eveyProductId : '';
    var variantId = getEveyVariantId(panel);
    var today = new Date();
    var end = addDays(today, 120);
    var url;

    if (!liveTimes || !window.fetch || !shop || !productId || !variantId) {
      return Promise.resolve([]);
    }

    today.setHours(12, 0, 0, 0);
    end.setHours(12, 0, 0, 0);

    url = new URL('https://api.eveyevents.com/production-v2/storefront/schedule');
    url.searchParams.set('shop', shop);
    url.searchParams.set('productId', productId);
    url.searchParams.set('variantId', variantId);
    url.searchParams.set('quantity', String(getGuestCount(panel)));
    url.searchParams.set('startDate', toIsoDate(today));
    url.searchParams.set('endDate', toIsoDate(end));
    url.searchParams.set('currentDate', toIsoDate(new Date()));

    return fetchWithTimeout(url.toString(), {}, 10000)
      .then(function (response) {
        if (!response.ok) throw new Error('Evey schedule returned ' + response.status);
        return response.json();
      })
      .then(function (data) {
        return data && data.schedule && Array.isArray(data.schedule.schedule_events)
          ? data.schedule.schedule_events
          : [];
      });
  }

  function makeEveyTimeButton(event, selectedValue) {
    var button = document.createElement('button');
    var date = document.createElement('strong');
    var time = document.createElement('span');
    var seats = document.createElement('span');
    var value = eveyEventValue(event);
    var available = Number(event.available);

    button.className = 'tours-booking__evey-time';
    button.type = 'button';
    button.dataset.eveyTimeOption = 'true';
    button.dataset.eveyEventValue = value;
    button.dataset.eveyEventLabel = formatEveyEventLabel(event);
    button.dataset.dateLabel = formatEveyButtonDate(event);
    button.dataset.timeSlot = formatEveyButtonTime(event);
    button.setAttribute('aria-pressed', value && value === selectedValue ? 'true' : 'false');
    button._mocamaEveyScheduleEvent = event;

    if (!available || available <= 0) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    }

    date.textContent = button.dataset.dateLabel;
    time.textContent = button.dataset.timeSlot;
    seats.textContent = available > 0 ? available + (available === 1 ? ' seat left' : ' seats left') : 'Sold out';

    button.appendChild(date);
    button.appendChild(time);
    button.appendChild(seats);

    return button;
  }

  function setEveyScheduledInfo(panel, label) {
    panel.querySelectorAll('[data-evey-scheduled-info]').forEach(function (node) {
      if (node.getAttribute('data-evey-scheduled-info') === 'value') {
        node.value = label;
      } else {
        node.textContent = label;
      }
    });
  }

  function selectEveyScheduleEvent(panel, event, shouldDispatch) {
    var value = eveyEventValue(event);
    var label = formatEveyEventLabel(event);
    var eventIdInput = panel.querySelector('[data-evey-event-id-input]');
    var eventLabelInput = panel.querySelector('[data-evey-event-label-input]');

    if (!value || !label) return;

    panel.querySelectorAll('[data-evey-time-option]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.dataset.eveyEventValue === value ? 'true' : 'false');
    });

    panel.dataset.eveySelectedEvent = value;
    assignHiddenInputValue(eventIdInput, value);
    assignHiddenInputValue(eventLabelInput, label);
    setEveyScheduledInfo(panel, label);
    readPanelState(panel);

    if (shouldDispatch !== false) {
      panel.dataset.eveyNativeDispatching = 'true';
      document.dispatchEvent(new CustomEvent('evey:recurring_date_change', { detail: { scheduleEvent: event } }));
      delete panel.dataset.eveyNativeDispatching;
    }
  }

  function clearEveyScheduleEvent(panel) {
    assignHiddenInputValue(panel.querySelector('[data-evey-event-id-input]'), '');
    assignHiddenInputValue(panel.querySelector('[data-evey-event-label-input]'), '');
    panel.querySelectorAll('[data-evey-time-option]').forEach(function (button) {
      button.setAttribute('aria-pressed', 'false');
    });
    setEveyScheduledInfo(panel, 'Choose date/time');
    delete panel.dataset.eveySelectedEvent;
    readPanelState(panel);
  }

  function showEveyFormError(panel, message) {
    var wrapper = panel.querySelector('.product-form__error-message-wrapper');
    var messageNode = wrapper ? wrapper.querySelector('.product-form__error-message') : null;

    if (!wrapper || !messageNode) return;

    if (message) {
      messageNode.textContent = message;
      wrapper.removeAttribute('hidden');
    } else {
      messageNode.textContent = '';
      wrapper.setAttribute('hidden', '');
    }
  }

  function renderEveyScheduleEvents(panel, events) {
    var liveTimes = panel.querySelector('[data-evey-live-times]');
    var list = panel.querySelector('[data-evey-live-times-list]');
    var status = panel.querySelector('[data-evey-live-times-status]');
    var fallback = panel.querySelector('[data-evey-scheduler-fallback]');
    var dateControl = panel.querySelector('[data-evey-date-control]');
    var datePicker = panel.querySelector('[data-evey-date-picker]');
    var eventInput = panel.querySelector('[data-evey-event-id-input]');
    var selectedValue = eventInput && eventInput.value ? eventInput.value : panel.dataset.eveySelectedEvent || '';
    var validEvents;
    var dateKeys;
    var selectedDateKey;
    var visibleEvents;
    var selectedEvent;
    var firstAvailable;

    if (!liveTimes || !list) return;

    validEvents = (events || [])
      .filter(function (event) {
        return event && event.start && event.schedule_item_id;
      })
      .filter(function (event) {
        return isEveyOutsideBookingCutoff(event);
      })
      .sort(function (a, b) {
        return new Date(a.start) - new Date(b.start);
      });

    panel._mocamaEveyScheduleEvents = validEvents;
    dateKeys = uniqueDateKeys(validEvents);

    if (!validEvents.length) {
      clear(list);
      var empty = document.createElement('p');
      empty.className = 'tours-booking__evey-times-empty';
      empty.textContent = 'No live Evey tour times are configured yet. Use the custom date option for now.';
      list.appendChild(empty);
      clearEveyScheduleEvent(panel);
      if (status) status.textContent = 'No times';
      if (dateControl) dateControl.setAttribute('hidden', '');
      if (fallback) {
        fallback.setAttribute('hidden', '');
        fallback.setAttribute('aria-hidden', 'true');
      }
      return;
    }

    selectedEvent = validEvents.filter(function (event) {
      return eveyEventValue(event) === selectedValue && Number(event.available) > 0;
    })[0];

    selectedDateKey = selectedEvent ? eveyEventDateKey(selectedEvent) : '';
    if (datePicker) {
      datePicker.min = dateKeys[0];
      datePicker.max = dateKeys[dateKeys.length - 1];
      if (datePicker.value && dateKeys.indexOf(datePicker.value) !== -1) {
        selectedDateKey = datePicker.value;
      }
      if (!selectedDateKey) selectedDateKey = dateKeys[0];
      datePicker.value = selectedDateKey;
    } else {
      selectedDateKey = selectedDateKey || dateKeys[0];
    }

    if (dateControl) dateControl.removeAttribute('hidden');

    visibleEvents = validEvents.filter(function (event) {
      return eveyEventDateKey(event) === selectedDateKey;
    });

    clear(list);

    if (!visibleEvents.length) {
      var noDateTimes = document.createElement('p');
      noDateTimes.className = 'tours-booking__evey-times-empty';
      noDateTimes.textContent = 'No public tour times are available for that date. Pick another date or use the custom date option.';
      list.appendChild(noDateTimes);
      clearEveyScheduleEvent(panel);
      if (status) status.textContent = dateKeys.length === 1 ? '1 date' : dateKeys.length + ' dates';
      if (fallback) {
        fallback.setAttribute('hidden', '');
        fallback.setAttribute('aria-hidden', 'true');
      }
      return;
    }

    visibleEvents.forEach(function (event) {
      list.appendChild(makeEveyTimeButton(event, selectedValue));
    });

    selectedEvent = visibleEvents.filter(function (event) {
      return eveyEventValue(event) === selectedValue && Number(event.available) > 0;
    })[0];
    firstAvailable = visibleEvents.filter(function (event) {
      return Number(event.available) > 0;
    })[0];

    if (selectedEvent || firstAvailable) {
      selectEveyScheduleEvent(panel, selectedEvent || firstAvailable, false);
      showEveyFormError(panel, '');
    } else {
      clearEveyScheduleEvent(panel);
    }

    if (status) {
      status.textContent = dateKeys.length === 1 ? '1 date' : dateKeys.length + ' dates';
    }

    if (fallback) {
      fallback.setAttribute('hidden', '');
      fallback.setAttribute('aria-hidden', 'true');
      fallback.classList.add('is-native-hidden');
    }
  }

  function renderEveyLiveTimes(panel) {
    var liveTimes = panel.querySelector('[data-evey-live-times]');
    var list = panel.querySelector('[data-evey-live-times-list]');
    var status = panel.querySelector('[data-evey-live-times-status]');
    var requestId;

    if (!liveTimes || !list) return;

    requestId = String(Date.now());
    panel.dataset.eveyScheduleRequestId = requestId;
    if (status) status.textContent = 'Checking Evey';

    fetchEveySchedule(panel)
      .then(function (events) {
        if (panel.dataset.eveyScheduleRequestId !== requestId) return;
        renderEveyScheduleEvents(panel, events);
      })
      .catch(function () {
        if (panel.dataset.eveyScheduleRequestId !== requestId) return;
        clear(list);
        clearEveyScheduleEvent(panel);
        var error = document.createElement('p');
        error.className = 'tours-booking__evey-times-empty';
        error.textContent = 'Live tour times could not load. Please try again or use the custom date option.';
        list.appendChild(error);
        if (status) status.textContent = 'Try again';
      });
  }

  function syncEveyForm(panel) {
    var activeTour = panel.querySelector('[data-tour-option][aria-pressed="true"]');
    var variantInput = panel.querySelector('[data-evey-variant-input]');
    var quantityInput = panel.querySelector('[data-evey-quantity-input]');
    var optionInput = panel.querySelector('[data-evey-option-property]');
    var guestOutput = panel.querySelector('[data-guest-count]');

    if (activeTour) {
      setInputValue(variantInput, activeTour.dataset.eveyVariantId);
      setInputValue(optionInput, activeTour.dataset.tourOption);
    }

    if (guestOutput) {
      setInputValue(quantityInput, guestOutput.textContent.trim());
    }
  }

  function applyUrlState(panel, tourButtons, guestOutput) {
    var params = new URLSearchParams(window.location.search);
    var requestedOption = params.get('tour_option');
    var requestedGuests = parseInt(params.get('guests') || '', 10);
    var matchingTour;

    if (requestedOption) {
      matchingTour = tourButtons.filter(function (button) {
        return button.dataset.tourOption === requestedOption;
      })[0];

      if (matchingTour) {
        setPressed(tourButtons, matchingTour);
      }
    }

    if (guestOutput && Number.isFinite(requestedGuests)) {
      guestOutput.textContent = String(Math.max(1, Math.min(12, requestedGuests)));
    }
  }

  function applyProductUrlState() {
    var params = new URLSearchParams(window.location.search);
    var requestedQuantity = parseInt(params.get('quantity') || params.get('guests') || '', 10);
    var quantityInput;

    if (!Number.isFinite(requestedQuantity)) return;

    quantityInput = document.querySelector('product-info input[name="quantity"], quantity-input input[name="quantity"]');
    if (!quantityInput) return;

    setInputValue(quantityInput, Math.max(1, Math.min(12, requestedQuantity)));
    quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function cleanTicketLabel(label) {
    return (label || '')
      .replace(/Variant sold out or unavailable/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function setupTourProductFormTracking() {
    var productInfo = document.querySelector('product-info.main-product--tour-booking');
    var form = productInfo ? productInfo.querySelector('product-form form[action*="/cart/add"]') : null;

    if (!productInfo || !form || form.dataset.mocamaTourTrackingSetup === 'true') return;
    form.dataset.mocamaTourTrackingSetup = 'true';

    form.addEventListener('submit', function () {
      var selectedTicket = productInfo.querySelector('variant-selects input[type="radio"]:checked + label');
      var quantityInput = productInfo.querySelector('input[name="quantity"]');
      var scheduleButton = productInfo.querySelector('.evey-scheduler-container [data-evey-scheduled-info], .evey-scheduler-container button');
      var tourOption = cleanTicketLabel(selectedTicket ? selectedTicket.textContent : '') || activePanelState.tourOption;
      var guests = quantityInput && quantityInput.value ? quantityInput.value : activePanelState.guests;
      var scheduledText = scheduleButton ? scheduleButton.textContent.replace(/\s+/g, ' ').trim() : '';
      var value = tourOption === 'Tour + Tasting' ? 35 : 18;

      dispatchBookingTracking({
        content_name: 'Brewery Tour Booking',
        content_category: 'Tours',
        tour_option: tourOption,
        value: value,
        currency: 'USD',
        guests: guests,
        booking_backend: 'evey_shopify',
        booking_placement: 'product_booking_step',
        booking_url: window.location.href,
        preferred_time: scheduledText && scheduledText !== 'Choose date/time' ? scheduledText : ''
      });
    }, true);
  }

  function setupBookingPanel(panel) {
    var tourButtons = Array.from(panel.querySelectorAll('[data-tour-option]'));
    var timingButtons = Array.from(panel.querySelectorAll('[data-timing-intent]'));
    var availabilityPanel = panel.querySelector('[data-availability-panel]');
    var stickyBooking = document.querySelector('.tours-sticky-booking');
    var guestOutput = panel.querySelector('[data-guest-count]');
    var decrease = panel.querySelector('[data-guest-decrease]');
    var increase = panel.querySelector('[data-guest-increase]');
    var panelLinks = Array.from(panel.querySelectorAll('[data-peek-booking-link]'));
    var eveyHandoffLinks = Array.from(panel.querySelectorAll('[data-evey-handoff-link]'));
    var eveyForm = panel.querySelector('[data-evey-product-form] form');
    var eveyLiveTimes = panel.querySelector('[data-evey-live-times]');
    var eveyDatePicker = panel.querySelector('[data-evey-date-picker]');

    function updatePanel() {
      readPanelState(panel);
      if (activePanelState.bookingBackend === 'evey') syncEveyForm(panel);
      eveyHandoffLinks.forEach(function (link) {
        updateEveyHandoffLink(link, link.dataset.bookingPlacement || 'booking_panel');
      });
      panelLinks.forEach(function (link) {
        updateLink(link, link.dataset.bookingPlacement || 'booking_panel');
      });
      syncAllPeekLinks();
    }

    function refreshAvailability() {
      if (availabilityPanel) renderAvailability(panel);
      if (eveyLiveTimes) renderEveyLiveTimes(panel);
      updatePanel();
    }

    tourButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setPressed(tourButtons, button);
        refreshAvailability();
      });
    });

    timingButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setPressed(timingButtons, button);
        panel.dataset.selectedDateOffset = button.dataset.timingIntent === 'pick' ? panel.dataset.selectedDateOffset || '2' : '';
        refreshAvailability();
      });
    });

    if (availabilityPanel) {
      availabilityPanel.addEventListener('click', function (event) {
        var dateButton = closest(event.target, '[data-date-choice]');
        var slotButton = closest(event.target, '[data-time-slot]');

        if (dateButton) {
          panel.dataset.selectedDateOffset = dateButton.dataset.dateChoice;
          refreshAvailability();
          return;
        }

        if (slotButton && !slotButton.disabled) {
          setPressed(Array.from(panel.querySelectorAll('[data-time-slot]')), slotButton);
          var summary = panel.querySelector('[data-availability-summary]');
          var activeDate = panel.querySelector('[data-date-choice][aria-pressed="true"]');
          var activeTiming = panel.querySelector('[data-timing-intent][aria-pressed="true"]');
          var timingKey = activeTiming ? activeTiming.dataset.timingIntent : 'today';
          var dateLabel = activeDate ? activeDate.dataset.dateLabel : longDateLabel(dateFromOffset(selectedDateOffsetFor(panel, timingKey)));

          if (summary) {
            summary.textContent = 'Selected: ' + slotButton.dataset.slotTitle + ' at ' + slotButton.dataset.timeSlot + ' on ' + dateLabel + '.';
          }

          updatePanel();
        }
      });
    }

    if (eveyLiveTimes) {
      eveyLiveTimes.addEventListener('click', function (event) {
        var timeButton = closest(event.target, '[data-evey-time-option]');

        if (!timeButton || timeButton.disabled || !timeButton._mocamaEveyScheduleEvent) return;
        selectEveyScheduleEvent(panel, timeButton._mocamaEveyScheduleEvent);
        updatePanel();
      });

      document.addEventListener('evey:recurring_date_change', function (event) {
        var scheduleEvent = event.detail && event.detail.scheduleEvent;
        var value = scheduleEvent ? eveyEventValue(scheduleEvent) : '';

        if (!scheduleEvent || panel.dataset.eveyNativeDispatching === 'true') return;

        panel.querySelectorAll('[data-evey-time-option]').forEach(function (button) {
          button.setAttribute('aria-pressed', button.dataset.eveyEventValue === value ? 'true' : 'false');
        });
        panel.dataset.eveySelectedEvent = value;
        readPanelState(panel);
      });
    }

    if (eveyDatePicker) {
      eveyDatePicker.addEventListener('change', function () {
        renderEveyScheduleEvents(panel, panel._mocamaEveyScheduleEvents || []);
        updatePanel();
      });
    }

    if (decrease && increase && guestOutput) {
      decrease.addEventListener('click', function () {
        var nextCount = Math.max(1, parseInt(guestOutput.textContent, 10) - 1);
        guestOutput.textContent = String(nextCount);
        refreshAvailability();
      });

      increase.addEventListener('click', function () {
        var nextCount = Math.min(12, parseInt(guestOutput.textContent, 10) + 1);
        guestOutput.textContent = String(nextCount);
        refreshAvailability();
      });
    }

    if (stickyBooking && 'IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(function (entries) {
        var panelVisible = entries.some(function (entry) {
          return entry.isIntersecting;
        });
        stickyBooking.classList.toggle('is-hidden', panelVisible);
      }, { threshold: 0.08 });

      stickyObserver.observe(panel);
    }

    applyUrlState(panel, tourButtons, guestOutput);

    if (eveyForm) {
      eveyForm.addEventListener('submit', function (event) {
        var scheduleButton = panel.querySelector('.evey-scheduler-container [data-evey-scheduled-info], .evey-scheduler-container button');
        var scheduledText = scheduleButton ? scheduleButton.textContent.replace(/\s+/g, ' ').trim() : '';
        var eventIdInput = panel.querySelector('[data-evey-event-id-input]');

        readPanelState(panel);
        syncEveyForm(panel);
        if (!eventIdInput || !eventIdInput.value) {
          event.preventDefault();
          event.stopImmediatePropagation();
          showEveyFormError(panel, 'Choose an available tour date and time before reserving seats.');
          renderEveyScheduleEvents(panel, panel._mocamaEveyScheduleEvents || []);
          return;
        }

        showEveyFormError(panel, '');
        trackBookingStartFromState({
          booking_backend: 'evey_shopify',
          booking_placement: 'booking_panel',
          booking_url: window.location.href,
          preferred_time: scheduledText && scheduledText !== 'Choose date/time' ? scheduledText : ''
        });
      }, true);
    }

    refreshAvailability();
  }

  function ensureFallbackModal() {
    var modal = document.querySelector('[data-mocama-peek-modal]');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'mocama-peek-modal';
    modal.setAttribute('data-mocama-peek-modal', '');
    modal.setAttribute('hidden', '');
    modal.innerHTML = [
      '<div class="mocama-peek-modal__backdrop" data-mocama-peek-close></div>',
      '<div class="mocama-peek-modal__panel" role="dialog" aria-modal="true" aria-label="Mocama tour booking">',
      '<button class="mocama-peek-modal__close" type="button" data-mocama-peek-close>Close</button>',
      '<iframe class="mocama-peek-modal__frame" title="Mocama tour booking" allow="payment" loading="lazy"></iframe>',
      '<a class="mocama-peek-modal__fallback" href="#" target="_blank" rel="noopener">Open secure checkout</a>',
      '</div>'
    ].join('');

    document.body.appendChild(modal);

    modal.addEventListener('click', function (event) {
      if (closest(event.target, '[data-mocama-peek-close]')) {
        closeFallbackModal(modal);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hasAttribute('hidden')) {
        closeFallbackModal(modal);
      }
    });

    return modal;
  }

  function closeFallbackModal(modal) {
    var frame = modal.querySelector('iframe');
    modal.setAttribute('hidden', '');
    document.documentElement.classList.remove('mocama-peek-open');
    if (frame) frame.src = 'about:blank';
  }

  function openFallbackModal(url) {
    var modal = ensureFallbackModal();
    var frame = modal.querySelector('iframe');
    var fallback = modal.querySelector('.mocama-peek-modal__fallback');
    var embedUrl = withBookingParams(url, { mode: 'embed' });

    if (frame) frame.src = embedUrl;
    if (fallback) fallback.href = url;
    modal.removeAttribute('hidden');
    document.documentElement.classList.add('mocama-peek-open');
    var closeButton = modal.querySelector('[data-mocama-peek-close]');
    if (closeButton) closeButton.focus();
  }

  function dispatchBookingTracking(detail) {
    detail = detail || {};

    if (window.mocamaTrackTourBookingStart) {
      window.mocamaTrackTourBookingStart(detail);
    } else if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', detail);
    }

    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: 'tour_booking_start' }, detail));
    }
  }

  function trackBookingStartFromState(extra) {
    var detail = Object.assign({
      content_name: 'Brewery Tour Booking',
      content_category: 'Tours',
      tour_option: activePanelState.tourOption,
      value: parseFloat(activePanelState.tourValue || '18'),
      currency: 'USD',
      timing_intent: activePanelState.timing,
      preferred_date: activePanelState.dateIso,
      preferred_date_label: activePanelState.dateLabel,
      preferred_time: activePanelState.timeSlot,
      booking_product: activePanelState.slotTitle,
      guests: activePanelState.guests,
      booking_backend: activePanelState.bookingBackend === 'evey' ? 'evey_shopify' : 'peek',
      booking_placement: 'page_link'
    }, extra || {});

    dispatchBookingTracking(detail);
  }

  function trackBookingStart(link, url) {
    trackBookingStartFromState({
      tour_option: link.dataset.tourOption || activePanelState.tourOption,
      value: parseFloat(link.dataset.tourValue || activePanelState.tourValue || '18'),
      timing_intent: link.dataset.timingIntent || activePanelState.timing,
      preferred_date: link.dataset.dateIso || activePanelState.dateIso,
      preferred_date_label: link.dataset.dateLabel || activePanelState.dateLabel,
      preferred_time: link.dataset.timeSlot || activePanelState.timeSlot,
      booking_product: link.dataset.slotTitle || activePanelState.slotTitle,
      guests: link.dataset.guestCount || activePanelState.guests,
      booking_backend: link.dataset.bookingBackend || 'peek',
      booking_placement: link.dataset.bookingPlacement || 'page_link',
      booking_url: url
    });
  }

  function openPeek(url) {
    if (
      window.PeekJsApi &&
      window.PeekJsApi.popup &&
      typeof window.PeekJsApi.popup.open === 'function'
    ) {
      window.PeekJsApi.popup.open(url);
      return;
    }

    openFallbackModal(url);
  }

  document.addEventListener('DOMContentLoaded', function () {
    applyProductUrlState();
    setupTourProductFormTracking();
    document.querySelectorAll('[data-tours-booking-panel]').forEach(setupBookingPanel);
    syncAllPeekLinks();
  });

  document.addEventListener('click', function (event) {
    var scrollLink = closest(event.target, 'a[data-booking-scroll]');
    var scrollTarget;

    if (scrollLink) {
      scrollTarget = document.querySelector(scrollLink.getAttribute('href'));
      if (scrollTarget) {
        event.preventDefault();
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }
  });

  document.addEventListener('click', function (event) {
    var requestLink = closest(event.target, 'a[data-tour-request-link]');
    if (!requestLink) return;

    dispatchBookingTracking({
      event_type: 'tour_request_start',
      content_name: 'Brewery Tour Request',
      content_category: 'Tours',
      tour_option: requestLink.dataset.tourRequestType || 'custom_request',
      booking_backend: 'email_request',
      booking_placement: 'booking_panel',
      booking_url: requestLink.href
    });
  });

  document.addEventListener('click', function (event) {
    var handoffLink = closest(event.target, 'a[data-evey-handoff-link]');
    if (!handoffLink) return;

    trackBookingStartFromState({
      tour_option: handoffLink.dataset.tourOption || activePanelState.tourOption,
      value: parseFloat(handoffLink.dataset.tourValue || activePanelState.tourValue || '18'),
      guests: handoffLink.dataset.guestCount || activePanelState.guests,
      booking_backend: 'evey_shopify',
      booking_placement: handoffLink.dataset.bookingPlacement || 'page_link',
      booking_url: handoffLink.href
    });

    if (handoffLink.target !== '_blank') {
      event.preventDefault();
      setTimeout(function () {
        window.location.href = handoffLink.href;
      }, 250);
    }
  });

  document.addEventListener('click', function (event) {
    var link = closest(event.target, 'a[data-peek-booking-trigger], a[href*="book.peek.com"]');
    if (!link) return;

    if (!link.dataset.peekBaseUrl) {
      link.dataset.peekBaseUrl = link.getAttribute('href');
    }

    updateLink(link);
    var url = link.href;

    event.preventDefault();
    event.stopImmediatePropagation();
    link.dataset.mocamaTracked = 'true';
    trackBookingStart(link, url);
    openPeek(url);
  }, true);
})();
